import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { OperationRegion } from "@/hooks/useOperationRegion";
import { ResolvedTheme } from "@/hooks/useTheme";
import { useNavBack } from "@/contexts/NavBackContext";

interface NavLogoProps {
  region: OperationRegion;
  theme?: ResolvedTheme; // 现在主要靠 CSS 驱动，prop 变为可选
}

/**
 * 根据运营区域和主题计算 Logo 路径
 */
export const getLogoUrl = (
  region: OperationRegion,
  theme: ResolvedTheme = "light",
): string => {
  const color = theme === "dark" ? "white" : "black";
  const regionSuffix = region === "domestic" ? "cn" : "en";
  return `/images/${color}-${regionSuffix}-logo.svg`;
};

export function NavLogo({ region }: NavLogoProps) {
  const navigate = useNavigate();
  const { config } = useNavBack();

  // 返回按钮模式
  if (config.enabled) {
    const handleBack = () => {
      if (config.onBack) {
        config.onBack();
      } else if (config.targetPath) {
        navigate(config.targetPath);
      } else {
        navigate(-1);
      }
    };

    return (
      <Button
        variant="ghost"
        size="icon"
        onClick={handleBack}
        aria-label="返回上一页"
      >
        <ArrowLeft className="size-5" />
      </Button>
    );
  }

  // 正常 Logo 模式 - 使用 CSS 切换替代 React State 切换
  // 这种方式能确保主题切换时 Logo 立即响应，且不会有刷新后才生效的问题
  return (
    <Link to="/" className="flex items-center gap-2">
      {/* 亮色模式下的 Logo (黑色) */}
      <img
        src={getLogoUrl(region, "light")}
        className="h-8 dark:hidden"
        alt="吞舟 TUNZO"
      />
      {/* 暗色模式下的 Logo (白色) */}
      <img
        src={getLogoUrl(region, "dark")}
        className="h-8 hidden dark:block"
        alt="吞舟 TUNZO"
      />
    </Link>
  );
}
